import Comment from "./Comment";
import { connect } from "react-redux";
import { AddComment, closeCommentForm } from "../../../redux/actions/newService/comment.actions";
import { getComments } from "../../../redux/actions/newService/comment.actions";
import { openAlertPopup, closeAlertPopup } from "../../../redux/actions/Alert/alert.action";
import { showErrorPopup } from "../../../redux/actions/customErrorPopup/customerrorpopup.action";

const mapStateToProps = (state) => {  
    return { 
      isAlert: false,
      isCommentFormOpen:state.newService.comment.isCommentFormOpen, 
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {     
      addComment: (payload,id) => {
        return dispatch(AddComment(payload,id))
      },
      closeCommentForm: () => {
        return dispatch(closeCommentForm())
      },
      getComments:(requestId,next=null)=>{
        return dispatch(getComments(requestId,next))
      },
      openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      },
      closeAlertPopup: () => {
          return dispatch(closeAlertPopup())
      },
      showErrorPopup: (errorHeader,errormessage,isnote) => {
        return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
      },
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Comment);


